<template>
  <div>
    <div class="head-box">
      <h4>{{ renderTitle() }}</h4>
      <div class="c-flex">
        <el-dropdown class="c-m-r-10" @command="handleMarkTag" v-if="reviewType == 1">
          <el-button type="primary">标记</el-button>
          <el-dropdown-menu slot="dropdown">
            <template v-for="(item, tagIndex) in options['payTag']">
              <el-dropdown-item :key="tagIndex" :command="item.value">
                {{ item.label }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-input
          style="width:230px;margin-right:10px"
          placeholder="请输入订单编号"
          v-model="searchOrderId"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            queryThroughOrderId();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              queryThroughOrderId();
            "
          ></el-button>
        </el-input> -->
        <!-- @command="handleMarkProject" -->
        <el-dropdown
          class="c-m-r-10"
          @command="couponReview"
          v-if="reviewType == 0 && type == 1 && osg.has('FinancialAudit?type=1,batchAudit')"
        >
          <el-button type="primary" v-if="osg.has('FinancialAudit?type=1,batchAudit')">
            批量审核
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <template
              v-for="(item, index) in [
                { label: '审核通过', value: 0 },
                { label: '审核不通过', value: 1 }
              ]"
            >
              <el-dropdown-item :key="index" :command="item.value">
                {{ item.label }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
        <el-input
          style="width: 330px"
          placeholder="请输入委托方/手机号/合同编号."
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- v-if="osg.has('FinancialAudit?type=1,export')" -->
        <el-button
          type="primary"
          v-if="
            type == 1 && reviewType == 1 && osg.has('FinancialAudit?type=1&reviewType=1,export')
          "
          @click="
            osg.doExport({
              'regex:client|string#or': searchValue,
              'is:type|integer#and': type, //pay类型 0工单 1优惠券
              'is:typeId|string#or': searchValue, //
              'regex:clientPhone|string#or': searchValue,
              'regex:contractNum|string#or': searchValue,
              'in:auditstate|array-integer#and':
                reviewType != '1' && type == '1' ? '0,1,2' : '0,1,2',
              'is:exts.refundType|integer#and': type == '1' && reviewType != '1' ? 1 : '', //退款类型 1优惠券
              'in:state|integer#and': 1,
              sortField: 'createTime',
              sortOrder: 'desc',
              beanName: 'pay',
              title: renderTitle()
            })
          "
          class="c-m-l-10"
        >
          数据导出
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          :row-class-name="tableRowClassName"
          @selection-change="selectionChange"
          @select="currentSelection"
          @select-all="
            $refs.table.clearSelection();
            selectedList = [];
          "
          highlight-current-row
        >
          <el-table-column fixed="right" width="100px" v-if="osg.has('FinancialAudit,Audit')">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="scope.row.exts.rmContract != '1'">
                    <template
                      v-if="
                        scope.row.tradeIn == '0' &&
                          (scope.row.auditstate == '1' || scope.row.auditstate == '4')
                      "
                    >
                      <el-dropdown-item
                        v-if="scope.row.orderType == 0"
                        @click.native="auditOperation(scope.row, false)"
                      >
                        审核退款
                      </el-dropdown-item>
                      <template slot-scope="scope" v-else>
                        <el-dropdown-item @click.native="handleReview('2', scope.row)">
                          审核通过
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="handleReview('0', scope.row)">
                          审核不通过
                        </el-dropdown-item>
                      </template>
                    </template>

                    <el-dropdown-item
                      v-if="
                        scope.row.orderType != '0' &&
                          (scope.row.auditstate == '0' || scope.row.auditstate == '2') &&
                          scope.row.tradeIn == '0' &&
                          osg.has('FinancialAudit,Review')
                      "
                      @click.native="auditOperation(scope.row, false)"
                    >
                      反审
                    </el-dropdown-item>

                    <template v-if="scope.row.tradeIn == '1' && scope.row.auditstate == '1'">
                      <template
                        v-if="
                          scope.row.tradeIn == '1' &&
                            scope.row.auditstate == '1' &&
                            !type &&
                            !reviewType
                        "
                      >
                        <template
                          v-if="
                            osg.has('FinancialAudit,onlineAudit') &&
                              scope.row.tradeIn == '1' &&
                              scope.row.auditstate == '1' &&
                              !type &&
                              !reviewType
                          "
                        >
                          <el-dropdown-item @click="handleReview('2', scope.row)">
                            审核通过[线上]
                          </el-dropdown-item>
                          <el-dropdown-item @click="handleReview('0', scope.row)">
                            审核不通过[线上]
                          </el-dropdown-item>
                        </template>
                      </template>
                    </template>
                  </template>
                  <el-dropdown-item
                    v-if="osg.has('FinancialAudit,exception')"
                    @click.native="openBizStackTrace(scope.row)"
                  >
                    业务跟踪
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <el-table-column type="selection" fixed width="55" v-if="type == '1'"></el-table-column>
          <el-table-column
            :prop="type == 1 ? 'tradeNo' : 'contractNum'"
            :label="type == 1 ? '交易编号' : '合同编号'"
            :width="type == 1 ? '220px' : '180px'"
            fixed
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="typeId"
            label="券号"
            width="150px"
            show-overflow-tooltip
            v-if="type == '1'"
          ></el-table-column>
          <!-- <el-table-column prop="paymentItems" label="订单编号" width="150px">
            <template slot-scope="scope">
              {{ Object.keys(scope.row.paymentItems)[0] }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="userId"
            label="委托方"
            width="130px"
            :formatter="formatUserId"
          ></el-table-column> -->
          <el-table-column
            prop="client"
            label="委托方"
            width="80px"
            v-if="type == 0"
          ></el-table-column>
          <el-table-column
            prop="clientPhone"
            label="委托方电话"
            width="110px"
            v-if="type == 0"
          ></el-table-column>
          <!-- <el-table-column prop="_id" label="流水号" width="160px"></el-table-column> -->
          <el-table-column
            prop="exts.payTag"
            label="标记"
            width="50px"
            show-overflow-tooltip
            :formatter="formatterPayTag"
            v-if="type == 0 || type == 1"
          ></el-table-column>
          <el-table-column
            prop="exts.payTagTime"
            label="标记时间"
            width="96px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="auditstate"
            label="审核状态"
            width="90px"
            show-overflow-tooltip
            :formatter="formatterAuditstate"
            v-if="reviewType != 1"
          ></el-table-column>
          <!-- <el-table-column
            prop="totalAmount"
            label="合同金额"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>-->
          <el-table-column
            prop="paidAmount"
            label="已收款金额"
            width="110px"
            show-overflow-tooltip
            v-if="type == 0"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.paidAmount < 0" style="color: red">
                {{ osg.amountFilter(scope.row.paidAmount) }}
              </span>
              <span v-else>
                {{ osg.amountFilter(scope.row.paidAmount) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="difference"
            label="未付金额"
            width="110px"
            show-overflow-tooltip
            v-if="type == 0"
          >
            <template slot-scope="scope">
              <span :style="`${scope.row.difference < 0 ? 'color:red' : 'color:#000'}`">
                {{ osg.amountFilter(scope.row.difference) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            :label="reviewType == 1 ? '支付金额' : '本次审核金额'"
            width="110px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :style="`${scope.row.price < 0 ? 'color:red' : 'color:#000'}`">
                {{ osg.amountFilter(scope.row.price) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payType"
            label="支付方式"
            width="80px"
            show-overflow-tooltip
            :formatter="formatterPayType"
          ></el-table-column>
          <el-table-column
            prop="tradeNo"
            label="交易编号"
            width="210px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="refundFee"
            label="退款金额"
            width="100px"
            show-overflow-tooltip
            v-if="type == 0"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.refundFee" style="color: red">
                {{ scope.row.refundFee }}
              </span>
              <span v-else>
                {{ scope.row.refundFee || 0 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="refundType"
            label="退款方式"
            width="80px"
            show-overflow-tooltip
            v-if="type == 0"
          >
            <template slot-scope="scope">
              {{ osg.codelabel('refundType', scope.row.refundType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="executor"
            label="付款人"
            width="70px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="orderType"
            label="款项类型"
            width="80px"
            show-overflow-tooltip
            :formatter="formatterOrderType"
            v-if="type == 0"
          ></el-table-column>
          <el-table-column
            prop="refundType2"
            label="退款类型"
            width="150px"
            show-overflow-tooltip
            v-if="type == 0"
          >
            <template slot-scope="scope">
              {{ osg.codelabel('refundType2', scope.row['refundType2']) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="payTime"
            label="付款时间"
            min-width="140px"
            show-overflow-tooltip
            v-if="type == 0"
          ></el-table-column>
          <el-table-column
            prop="createUserName"
            label="操作人"
            width="90px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="memo"
            label="备注"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="comments"
            label="审批批语"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="auditstate2Time"
            label="审核时间"
            width="140px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.auditstate == '2' || scope.row.auditstate == '0'
                  ? scope.row.auditstate2Time
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="tradeIn"
            label="支付类型"
            width="70px"
            show-overflow-tooltip
            :formatter="formatterTradeIn"
          ></el-table-column>
          <el-table-column
            label="操作类型"
            width="70px"
            show-overflow-tooltip
            :formatter="formatterPaymentRecordType"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            min-width="140px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="修改时间"
            min-width="140px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.payCarryOverMoney"
            label="结转金额"
            min-width="110px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.amountFilter(scope.row.exts.payCarryOverMoney) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="exts.payCarryOverTime"
            label="结转时间"
            min-width="110px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="partnerName"
            label="服务商名称"
            min-width="160px"
            show-overflow-tooltip
            v-if="type == 0"
          ></el-table-column>
          <el-table-column
            prop="exts.rmContract"
            label="是否红冲"
            width="70px"
            show-overflow-tooltip
            :formatter="formatterPayState"
          >
            <template slot-scope="scope">
              {{ scope.row.exts && scope.row.exts.rmContract ? '是' : '否' }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="payState"
            label="收款状态"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterPayState"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="createTime"
            label="创建时间"
            width="150px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <template v-for="(extFiel, index) in extFields">
            <el-table-column
              min-width="180px"
              show-overflow-tooltip
              :label="extFiel.nameDisp"
              :key="index"
              v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
            >
              <template slot-scope="scope">
                {{ formatterCodelabel(scope.row.exts[extFiel.name], extFiel.valueOption) }}
              </template>
            </el-table-column>
          </template> -->
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="财务审核"
      :visible.sync="openDetail"
      id="FinancialAuditDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :class="seeDetails ? 'c_no_pointer' : ''"
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="140px"
        label-position="left"
        hide-required-asterisk:true
      >
        <!-- <el-form-item label="付款时间" >
          <div>{{ formData.payTime }}</div>
        </el-form-item> -->
        <el-form-item label="备注">
          <div slot="label" style="line-height: 20px;">
            <div>备注</div>
            <div style="font-size: 12px;color: #b1afaf;">
              <i class="el-icon-info"></i>
              减项内容及原因
            </div>
          </div>
          <div>{{ formData.memo }}</div>
        </el-form-item>
        <el-form-item label="本次审核金额（元）">
          <div style="color: red">{{ formData.price }}</div>
        </el-form-item>
        <el-form-item label="优惠后合同金额" v-if="queryContractList && queryContractList[0]">
          <div>{{ queryContractList[0].afterRefundMoney }}</div>
        </el-form-item>
        <el-form-item label="差额">
          <div>{{ formData.difference }}</div>
        </el-form-item>
        <el-form-item
          label="审核"
          prop="auditstate"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '审核不能为空'
          }"
        >
          <template>
            <el-radio v-model.number="formData.auditstate" :label="2">通过</el-radio>
            <el-radio v-model.number="formData.auditstate" :label="0">不通过</el-radio>
          </template>
        </el-form-item>
        <!-- <el-form-item
          v-if="formData.orderType == 0 && !(formData.auditstate === 0)"
          label="退款类型"
          prop="refundType2"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '退款类型不能为空'
          }"
        >
          <template>
            <el-radio v-model.number="formData.refundType2" :label="1">
              免付尾款
            </el-radio>
            <el-radio v-model.number="formData.refundType2" :label="2">
              退已付款
            </el-radio>
            <el-radio v-model.number="formData.refundType2" :label="3">
              免付尾款和退已付款
            </el-radio>
          </template>
        </el-form-item> -->
        <el-form-item
          label="审核批语"
          prop="comments"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '审核批语不能为空'
          }"
        >
          <el-input
            type="textarea"
            placeholder="审核批语"
            v-model="formData.comments"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table ref="tableF" :data="refundablePayList" style="width: 100%">
        <el-table-column
          prop="contractNum"
          label="合同编号"
          width="220px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="client" label="委托方" width="130px"></el-table-column>
        <el-table-column prop="clientPhone" label="委托方电话" width="110px"></el-table-column>
        <el-table-column
          prop="exts.payTag"
          label="标记"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPayTag"
        ></el-table-column>
        <el-table-column
          prop="auditstate"
          label="审核状态"
          width="130px"
          show-overflow-tooltip
          :formatter="formatterAuditstate"
        ></el-table-column>
        <el-table-column prop="price" label="收款金额" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.price < 0" style="color: red">
              {{ scope.row.price }}
            </span>
            <span v-else>
              {{ scope.row.price }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="refundFee" label="退款金额" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="`${scope.row.refundFee < 0 ? 'color:red' : 'color:#000'}`">
              {{ scope.row.refundFee }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="price" label="本次审核金额" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="`${scope.row.price < 0 ? 'color:red' : 'color:#000'}`">
              {{ scope.row.price }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="payType"
          label="支付方式"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPayType"
        ></el-table-column>
        <el-table-column
          prop="executor"
          label="申请人"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orderType"
          label="款项类型"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterOrderType"
        ></el-table-column>

        <el-table-column
          prop="payTime"
          label="付款时间"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createUserName"
          label="操作人"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="memo"
          label="备注"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="comments"
          label="审批批语"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="auditstate2Time"
          label="审核时间"
          width="150px"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              scope.row.auditstate == '2' || scope.row.auditstate == '0'
                ? scope.row.auditstate2Time
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradeIn"
          label="支付类型"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterTradeIn"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="操作类型"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPaymentRecordType"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="partnerName"
          label="服务商名称"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="exts.rmContract"
          label="是否红冲"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPayState"
        >
          <template slot-scope="scope">
            {{ scope.row.exts && scope.row.exts.rmContract ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="100" label="可退款金额" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ osg.amountFilter(refundAmountMax(scope.row.price, scope.row.refundFee)) }}
          </template>
        </el-table-column>
        <el-table-column label="本次退款金额" fixed="right" width="180">
          <template slot-scope="scope">
            <el-input-number
              style="width: 100%"
              type="number"
              :disabled="scope.row.exts.isDisable"
              :max="refundAmountMax(scope.row.price, scope.row.refundFee)"
              :precision="2"
              :controls="false"
              v-model="scope.row._refundFee"
              placeholder="请输入金额"
            ></el-input-number>
            <!-- @blur="refundablePriceBlur(scope.row)" -->
          </template>
        </el-table-column>
        <el-table-column label="退款路径" fixed="right" width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row._refundType"
              :disabled="
                scope.row.payType != '7' ||
                  formData.exts.refundType == '2' ||
                  scope.row.exts.isDisable
              "
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in [{ label: '保融退回', value: '0' }, { label: '线下', value: '1' }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" v-if="!seeDetails">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="财务反审" :visible.sync="openRetrialDetail" id="FinancialAuditDialog">
      <el-form
        :class="seeDetails ? 'c_no_pointer' : ''"
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="140px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="付款时间">
          <div>{{ formData.payTime }}</div>
        </el-form-item>
        <el-form-item label="本次审核金额（元）">
          <div>{{ formData.price || 0 }}</div>
        </el-form-item>
        <!-- <el-form-item label="合同总金额（元）">
          <div>{{ formData.totalPrice || 0 }}</div>
        </el-form-item> -->
        <el-form-item
          label="反审原因"
          prop="comments"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '反审原因不能为空'
          }"
        >
          <el-input
            type="textarea"
            placeholder="反审原因"
            v-model="formData.comments"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table
        ref="tableF"
        :data="refundablePayList"
        style="width: 100%"
        v-if="refundablePayList && refundablePayList.length"
      >
        <el-table-column
          prop="contractNum"
          label="合同编号"
          width="220px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="client" label="委托方" width="130px"></el-table-column>
        <el-table-column prop="clientPhone" label="委托方电话" width="110px"></el-table-column>
        <el-table-column
          prop="auditstate"
          label="审核状态"
          width="130px"
          show-overflow-tooltip
          :formatter="formatterAuditstate"
        ></el-table-column>
        <el-table-column prop="paidAmount" label="已收款金额" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.paidAmount < 0" style="color: red">
              {{ scope.row.paidAmount }}
            </span>
            <span>
              {{ scope.row.paidAmount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="difference" label="未付金额" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="`${scope.row.difference < 0 ? 'color:red' : 'color:#000'}`">
              {{ scope.row.difference }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="本次审核金额" width="150px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="`${scope.row.price < 0 ? 'color:red' : 'color:#000'}`">
              {{ scope.row.price }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="payType"
          label="支付方式"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPayType"
        ></el-table-column>
        <el-table-column
          prop="executor"
          label="申请人"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orderType"
          label="款项类型"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterOrderType"
        ></el-table-column>
        <el-table-column
          prop="payTime"
          label="付款时间"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createUserName"
          label="操作人"
          width="150px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="memo"
          label="备注"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="comments"
          label="审批批语"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="auditstate2Time"
          label="审核时间"
          width="150px"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              scope.row.auditstate == '2' || scope.row.auditstate == '0'
                ? scope.row.auditstate2Time
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tradeIn"
          label="支付类型"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterTradeIn"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="操作类型"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPaymentRecordType"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="partnerName"
          label="服务商名称"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="exts.rmContract"
          label="是否红冲"
          width="150px"
          show-overflow-tooltip
          :formatter="formatterPayState"
        >
          <template slot-scope="scope">
            {{ scope.row.exts && scope.row.exts.rmContract ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="本次退款金额" fixed="right" width="220">
          <template slot-scope="scope">
            <el-input
              @blur="refundablePriceBlur(scope.row)"
              v-model="scope.row._refundFee"
              type="number"
              placeholder="请输入金额"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="退款方式" fixed="right" width="220">
          <template slot-scope="scope">
            <el-select v-model="scope.row._refundType" clearable placeholder="请选择">
              <el-option
                v-for="item in [{ label: '保融退回1', value: '0' }, { label: '线下', value: '1' }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" v-if="!seeDetails">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="操作记录" :visible.sync="openHistory" id="FinancialAuditDialog">
      <div class="box-center-content" :infinite-scroll-immediate="true">
        <template v-if="historyFpi.data.length">
          <div class="activity-card" v-for="(item, i) in historyFpi.data" :key="i">
            <div class="activity-card-header">
              <span class="c-font-500">
                <i class="el-icon-document c-w-30"></i>
                {{ item.operation }}
                <span v-if="item.memo">（{{ item.memo }}）</span>
              </span>
              <span>{{ item.createTime }}</span>
            </div>
            <div class="activity-card-content">
              <el-table :data="item.modifyList" style="width: 100%" size="mini">
                <el-table-column
                  prop="field"
                  label="字段"
                  width="90"
                  show-overflow-tooltip
                  :formatter="formatField"
                ></el-table-column>
                <el-table-column
                  prop="pfrom"
                  label="修改前"
                  :formatter="formatFieldValue"
                ></el-table-column>
                <el-table-column
                  prop="pto"
                  label="修改后"
                  :formatter="formatFieldValue"
                ></el-table-column>
              </el-table>
            </div>
            <div class="activity-card-footer">
              <span>操作人：{{ item.createUserName }}</span>
            </div>
          </div>
        </template>
        <div class="activity-card" v-else><div class="activity-card-header">暂无操作记录</div></div>
      </div>
    </el-dialog>
    <el-dialog
      title="业务跟踪"
      :visible.sync="bizStackTraceOpen"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="bizStackTraceDialog"
    >
      <bizStackTrace :params="{ sid: formData._id }" v-if="bizStackTraceOpen"></bizStackTrace>
      <div slot="footer" v-if="false">
        <el-button @click="bizStackTraceOpen = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'FinancialAudit',
  inject: ['viewReload'], //注入nav里的viewReload方法
  components: {
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  data() {
    return {
      name: 'pay',
      fpi: {},
      searchValue: '',
      openDetail: false,
      openRetrialDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      params: {},
      contactList: [], //客户列表
      SAlist: [], //工单列表
      orderList: [], //订单列表
      dynamic: {}, //手动从其他表收集添加动态列都会存放在这一份，方便以后删除
      options: {
        codecfg_auditstate: { codeId: 'auditstate' },
        codecfg_payState: { codeId: 'payState' },
        codecfg_payType: { codeId: 'payType' },
        codecfg_PaymentRecordType: { codeId: 'PaymentRecordType' },
        codecfg_orderPayType: { codeId: 'orderPayType' },
        codecfg_tradeIn: { codeId: 'tradeIn' },
        codecfg_payTag: { codeId: 'payTag' }, //支付标记
        codecfg_refundType: { codeId: 'refundType' }, //支付退款审核类型
        codecfg_refundType2: { codeId: 'refundType2' } //支付退款退款类型
      },
      seeDetails: false, //查看详情的状态,true则只能看
      searchOrderId: '', //搜索订单id
      queryOrderList: [], // pay列表所需的订单列表
      queryContractList: [], // pay列表所需的合同列表
      refundablePayList: [], //可退款的审核记录列表
      type: 0, //0=工单；1=优惠券
      selectedList: [], //被选中的pay（list）
      reviewType: 0, //默认0，1为优惠券的审核
      openHistory: false, // 操作记录弹窗
      // 操作记录列表
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      bizStackTraceOpen: false //业务跟踪弹窗
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  created() {
    this.type = this.$route.query.type || 0; //pay类型
    this.reviewType = this.$route.query.reviewType || 0; //优惠券审核
  },
  mounted() {
    this.doInit();
    this.osg.getFields('serviceAppointment', () => {
      this.osg.getFpi();
      this.getData(); //包含getData且动态添加列
      this.options['payTag'].unshift({ label: '取消标记', value: '' });
    });
  },
  methods: {
    getData() {
      this.getPayData();
      //pay对象列表动态调用其他对象列表动态增加列，目前这种方法解决影响最小
      //   this.getPayData(dataObj => {
      // let p1 = this.getContacts(dataObj.contactIds);
      // let p2 = this.getSA(dataObj.SAids);
      // let p3 = this.queryOrder(dataObj.orderIds);
      // let p3 = this.queryContract(dataObj.contractNumIds);
      // console.log(dataObj.orderIds);
      // Promise.all([p1, p2, p3])
      // Promise.all([])
      //   .then(() => {
      //给工单列表动态的加列，因为后端支付表里没有工单、订单、客户的一些字段
      // for (let fpiItem of this.fpi.data) {
      //   for (let contactItem of this.contactList) {
      //     if (fpiItem.userId == contactItem._id) {
      //       fpiItem.phone = contactItem.phone;
      //     }
      //   }
      //   for (let SAitem of this.SAlist) {
      //     if (fpiItem.serviceAppointmentId == SAitem._id) {
      //       fpiItem.totalAmount = SAitem.totalAmount;
      //       fpiItem.paidAmount = SAitem.paidAmount;
      //     }
      //   }
      //订单动态加列
      //   for (let QorderItem of this.queryOrderList) {
      //     if (Object.keys(fpiItem.paymentItems)[0] == QorderItem._id) {
      //       fpiItem.totalAmount = QorderItem.totalAmount;
      //       fpiItem.paidAmount = QorderItem.paidAmount;
      //       //差额，页面要展示未付金额
      //       let differenceNum =
      //         this.amountToFixed(
      //           this.amountToFixed(QorderItem.totalPrice) -
      //             this.amountToFixed(QorderItem.paidAmount)
      //         ) || 0;
      //       fpiItem.difference = differenceNum;
      //       //   fpiItem.difference = differenceNum < 0 ? Math.abs(differenceNum) : -differenceNum;
      //     }
      //   }
      //合同动态加列
      //   for (let contractItem of this.queryContractList) {
      //     if (fpiItem.contractNum == contractItem.contractdocNum) {
      //       //   let data = JSON.parse(JSON.stringify(contractItem));
      //       // fpiItem.totalAmount = contractItem.totalAmount;
      //       fpiItem.paidAmount = contractItem.paidAmount || 0; //已收款金额
      //       //差额，页面要展示未付金额
      //       fpiItem.difference = contractItem.difference || 0; //未付金额
      //     }
      //   }
      // }
      //动态加的字段，存储在这个对象上，可能未来会使用
      // this.dynamic.phone = 'phone';
      // this.dynamic.totalAmount = 'totalAmount';
      // this.dynamic.paidAmount = 'paidAmount';
      // this.dynamic.clientName = 'clientName';
      // this.fpi.data = [...this.fpi.data];
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      //   });
    },
    //渲染标题
    renderTitle() {
      if (this.type == 1) {
        return this.reviewType == 1 ? ' 优惠券支付记录' : '优惠券审核';
      } else {
        return '财务审核';
      }
    },
    getPayData(callBack) {
      this.params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        // 'in:auditstate|array-integer#and': '', //审计状态 0:审核未通过;1:审核中;2:审核通过完成;99自由态
        'regex:client|string#or': this.searchValue,
        'is:type|integer#and': this.type, //pay类型 0工单 1优惠券
        'is:typeId|string#or': this.searchValue, //
        'regex:clientPhone|string#or': this.searchValue,
        'regex:contractNum|string#or': this.searchValue,
        'in:auditstate|array-integer#and':
          this.reviewType != '1' && this.type == '1' ? '0,1,2' : '0,1,2,3,4',
        'is:exts.refundType|integer#and': this.type == '1' && this.reviewType != '1' ? 1 : '', //退款类型 1优惠券
        'in:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(this.params);
      this.osg.setFpi(this.params);
      this.osg.ajax('i/pay/query.do', this.params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        //收集客户id和工单id一起获取，用于后面反显和动态给表格插列
        // let contactIds = res.data.map(item => item.userId);
        // let SAids = res.data.map(item => item.serviceAppointmentId);
        // let orderIds = res.data.map(item => Object.keys(item.paymentItems)[0]);
        // let contractNumIds = res.data.map(item => item.contractNum);

        // if (callBack) callBack({ contactIds, SAids, orderIds, contractNumIds });
      });
    },
    // queryThroughOrderId() {
    //   this.params = {
    //     page: this.fpi.page || 1,
    //     rows: this.fpi.rows || 20,
    //     orderId: this.searchOrderId,
    //     'gt:state|integer#and': '-1',
    //     sortField: 'createTime',
    //     sortOrder: 'desc'
    //   };
    //   // this.params[`gt:paymentItems.${this.SAid}|map#and`] = 0;
    //   this.osg.ajax('i/pay/queryThroughOrderId.do', this.params, res => {
    //     this.fpi = res;
    //     let contactIds = res.data.map(item => item.userId);
    //     let orderIds = res.data.map(item => Object.keys(item.paymentItems)[0]);
    //     let SAids = res.data.map(item => item.serviceAppointmentId);
    //     let p1 = this.getContacts(contactIds);
    //     let p2 = this.getSA(SAids);
    //     let p3 = this.queryOrder(orderIds);
    //     Promise.all([p1, p2, p3])
    //       .then(() => {
    //         //给工单列表动态的加列，因为后端支付表里没有工单、客户的一些字段
    //         for (let fpiItem of this.fpi.data) {
    //           for (let contactItem of this.contactList) {
    //             if (fpiItem.userId == contactItem._id) {
    //               fpiItem.phone = contactItem.phone;
    //             }
    //           }
    //           for (let SAitem of this.SAlist) {
    //             if (fpiItem.serviceAppointmentId == SAitem._id) {
    //               fpiItem.totalAmount = SAitem.totalAmount;
    //               fpiItem.paidAmount = SAitem.paidAmount;
    //             }
    //           }
    //           for (let QorderItem of this.queryOrderList) {
    //             if (Object.keys(fpiItem.paymentItems)[0] == QorderItem._id) {
    //               fpiItem.clientName =
    //                 QorderItem.exts.clientname ||
    //                 QorderItem.exts.companyName ||
    //                 QorderItem.ownerName;
    //             }
    //           }
    //         }
    //         //动态加的字段，存储在这个对象上，可能未来会使用
    //         this.dynamic.phone = 'phone';
    //         this.dynamic.totalAmount = 'totalAmount';
    //         this.dynamic.paidAmount = 'paidAmount';
    //         this.dynamic.clientName = 'clientName';
    //         this.fpi.data = [...this.fpi.data];
    //         this.$refs.table.doLayout();
    //         this.$forceUpdate();
    //       })
    //       .catch(err => {
    //         console.log(err);
    //       });
    //   });
    // },
    tableRowClassName({ row, state }) {
      if (this.type == 1 && this.reviewType == 1) return; //优惠券支付记录不展示颜色
      if (row.auditstate == 1) {
        return 'default-row';
      } else if (row.auditstate == 0) {
        return 'warning-row';
      } else if (row.auditstate == 2) {
        return 'success-row';
      }
      return '';
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    //被选中的支付记录
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //勾选当前行
    currentSelection(rows, row) {
      if (!(this.type == 1 && this.reviewType == 1)) {
        if (row.auditstate != 1) {
          this.osg.toast('已审核的不能勾选！', 'warning');
          this.$refs.table.toggleRowSelection(rows.pop(), false);
        }
      }
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        //清除动态添加的列
        // for (let key in this.dynamic) {
        //   delete this.formData[key];
        // }
        if (this.formData.orderType == 0 && this.formData.auditstate == '2') {
          if (this.refundablePayList.length <= 0) {
            this.osg.toast('没有可退款的支付记录！', 'warning');
            return;
          }
          //计算退款金额总和
          let refundablePrice = 0;
          for (let pay of this.refundablePayList) {
            refundablePrice = this.amountToFixed(
              this.amountToFixed(refundablePrice) + this.amountToFixed(-Math.abs(pay._refundFee))
            );
            if (!pay._refundType) {
              this.osg.toast('请选择退款方式！', 'warning');
              return;
            }
          }

          //选择免付尾款时，退款总金额必须等于0 逻辑判断
          if (this.formData.refundType2 == 1) {
            if (refundablePrice != 0) {
              this.osg.toast('选择免付尾款时，退款总金额必须等于0！', 'warning');
              return;
            }
          } else {
            if (this.formData.price != refundablePrice) {
              console.log(this.formData.price, refundablePrice);
              this.osg.toast('退款金额必须等于本次审核金额！', 'warning');
              return;
            }
          }
          // console.log(this.formData, this.refundablePayList);
          //退款金额和退款方式放到外部
          let refundList = this.refundablePayList
            .map(item => {
              //只有退款金额大于0才往里面放
              if (item._refundFee >= 0) {
                let obj = {};
                obj.refundFree = -Math.abs(item._refundFee);
                obj.type = item._refundType || '1'; //退款方式默认1 线下
                obj.payId = item._id;
                if (item.state == '2') obj.state = item.state;
                // delete item._refundFee; //前端专用字段，退款金额
                // delete item._refundType; //前端专用字段，退款方式
                // obj.pay = item;
                return obj;
              }
            })
            .filter(item => item && +item.refundFree);  
          let refundMap = {
            list: refundList,
            comments: this.formData.comments || '',
            totalRefund: this.formData.price, //将本次审核金额转为正数
            payId: this.formData._id,
            refundType2: this.formData.refundType2 //退款类型 1免付尾款 2退尾款 3 免付尾款+退尾款
          };
          this.osg.ajax(
            'i/pay/refund.do',
            { refund: JSON.stringify(refundMap) },
            res => {
              if (res.data && res.data.contractId) {
                this.$confirm(res.message || '该合同已结算，是否需要退款?', '提示', {
                  confirmButtonText: '需要',
                  cancelButtonText: '不需要',
                  type: 'warning'
                }).then(() => {
                  this.osg.ajax(
                    'i/markEmbodiment/all.do',
                    {
                      data: JSON.stringify([
                        {
                          id: res.data.contractId,
                          name: 'settleMark',
                          value: '2',
                          className: 'com.fsgo.entity.basic.Contract'
                        }
                      ])
                    },
                    res => {
                      this.$message({
                        type: 'success',
                        message: '操作成功!'
                      });
                    }
                  );
                });
              }
              this.doInit();
              this.getData();
              this.osg.toast('保存成功！');
            },
            {
              fail: () => {
                this.doInit();
                this.getData();
              }
            }
          );
        } else {
          this.osg.ajax(
            'i/pay/upsert.do',
            this.formData,
            res => {
              this.doInit();
              this.getData();
              this.osg.toast('保存成功！');
            },
            {
              fail: () => {
                this.doInit();
                this.getData();
              }
            }
          );
        }
      }
    },
    doInit() {
      this.openDetail = false;
      this.openRetrialDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    getContacts(contactIds) {
      return new Promise((resolve, reject) => {
        if (!contactIds.length) {
          reject('没有订单ids');
          return;
        }
        this.params = {
          _all: '1',
          'in:_id|Array#and': contactIds.join()
        };
        this.osg.ajax('basic/contacts/query.do', this.params, res => {
          if (res && res.data && contactIds) {
            this.contactList = res.data;
            resolve();
          }
        });
      });
    },
    getSA(SAids) {
      return new Promise((resolve, reject) => {
        if (!SAids.length) {
          reject('没有工单ids');
          return;
        }
        this.params = {
          _all: '1',
          'in:_id|Array#and': SAids.join()
        };
        this.osg.ajax('basic/serviceAppointment/query.do', this.params, res => {
          if (res && res.data && SAids) {
            this.SAlist = res.data;
            resolve();
          }
        });
      });
    },
    //弹窗审核
    async auditOperation(row, isSeeDetails) {
      this.seeDetails = isSeeDetails;
      this.refundablePayList = [];
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);

      this.formData = row;
      if (row.orderType == 0) {
        this.formData.refundType2 = 2; //退款类型默认“退已付款”
        await this.getRefundablePay(row); //当审核款项类型是退款时，查看可退款的审核记录
      }
      if (row.auditstate == '1' || row.auditstate == '4') {
        //审核
        this.formData.auditstate = '';
        this.openDetail = true;
        this.refundablePayList.map(item => {
          if (item.exts.refunds) {
            let refundItem = item.exts.refunds.find(rItem => rItem.bizId == this.formData._id);
            //判断exts里的refunds 是否与外层的payid一致，如果一致则不允许编辑
            if (refundItem) {
              if (refundItem.state == '2') item.exts.isDisable = true;
              item._refundFee = Math.abs(refundItem.refundFree);
            }
          }
          return item;
        });
        // this.formData.id =
        this.queryContract([this.formData.contractNum]);
      } else if (row.auditstate == '2' || row.auditstate == '0') {
        //反审
        this.formData.auditstate = '1';
        this.openRetrialDetail = true;
      }
    },
    //优惠券批量审核
    couponReview(flag) {
      let list = this.selectedList.map(item => item.typeId);
      if (list && list.length) {
        this.osg.confirm('确定批量审核这些吗？', () => {
          this.osg.ajax('basic/couponPrinting/examine.do', { list: list.join(','), flag }, res => {
            this.selectedList = [];
            this.getData();
            this.osg.toast('操作成功！');
          });
        });
      } else {
        this.osg.toast('请至少选择一个！', 'warning');
      }
    },
    //快捷审核
    handleReview(flag, row) {
      row = this.$util.deepCopy(row);
      this.$prompt('请输入审核批语', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: flag == '2' ? null : /\S/,
        inputErrorMessage: '审核批语不能为空',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          //   auditstate 通过:2 ，不通过:0
          this.formData = row;
          if (row.auditstate == '1') {
            //审核
            this.formData.auditstate = flag;
            this.formData.comments = value || '';
            this.osg.ajax('i/pay/upsert.do', this.formData, res => {
              this.doInit();
              this.getData();
              this.osg.toast('操作成功！');
            });
          } else {
            this.osg.toast('审核状态有误，请联系管理员！', 'info');
          }
        })
        .catch(() => {
          //   this.osg.toast('取消审核', 'info');
        });
    },
    //分页列表所需请求订单
    queryOrder(orderIds) {
      return new Promise((resolve, reject) => {
        this.params = {
          //   page: this.fpi.page || 1,
          //   rows: this.fpi.rows || 20,
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc',
          'is:type|integer#and': 1,
          'is:state|integer#and': 1,
          'in:_id|array#and': orderIds.join()
        };
        this.osg.ajax('basic/order/query.do', this.params, res => {
          if (res && res.data) {
            this.queryOrderList = res.data;
            resolve();
          }
        });
      });
    },
    //分页列表所需请求合同
    queryContract(contractNumIds) {
      return new Promise((resolve, reject) => {
        this.params = {
          //   page: this.fpi.page || 1,
          //   rows: this.fpi.rows || 20,
          _all: '1',
          sortField: 'createTime',
          sortOrder: 'desc',
          'in:contractdocNum|array#and': contractNumIds.join()
        };
        this.osg.ajax('basic/contract/query.do', this.params, res => {
          if (res && res.data) {
            this.queryContractList = res.data;
            resolve();
          }
        });
      });
    },
    //查看可退款的审核记录
    getRefundablePay(row) {
      return new Promise(resolve => {
        this.params = {
          sortField: 'createTime',
          sortOrder: 'desc',
          'in:auditstate|array-integer#and': '2', //审核通过
          contractNum: row.contractNum,
          'ne:orderType|integer#and': '0',
          'is:state|integer#and': '1',
          'gt:price|integer#and': '0'
        };
        this.osg.ajax('/i/pay/query.do', this.params, res => {
          if (res && res.data) {
            this.refundablePayList = res.data.map(item => {
              item.payType == '7' ? (item._refundType = '0') : (item._refundType = '1');
              return item;
            });
            resolve(this.refundablePayList);
            this.$nextTick(() => {
              this.$refs.tableF.doLayout();
              this.$forceUpdate();
            });
          }
        });
      });
    },
    //支付标记
    handleMarkTag(command) {
      let tagTimeList = []; //标记时间
      this.selectedList.forEach(item =>
        tagTimeList.push({
          id: item._id,
          name: 'payTagTime',
          value: command === '' ? '' : this.$util.readableTime()
        })
      );
      //标记标签
      let tagList = this.selectedList.map(item => {
        return {
          id: item._id,
          name: 'payTag',
          value: command
        };
      });
      tagList = tagList.concat(tagTimeList);
      if (tagList && tagList.length) {
        console.log(tagList);
        this.markTagAjax(JSON.stringify(tagList));
      } else {
        this.osg.toast('请至少选择一个！', 'warning');
      }
    },
    //调用标记接口
    markTagAjax(data) {
      this.osg.confirm('确定标记这些吗？', () => {
        this.osg.ajax('i/pay/markEmbodiment.do', { data }, res => {
          this.selectedList = [];
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    //打开业务跟踪弹窗
    openBizStackTrace(row) {
      this.formData = this.$util.deepCopy(row);
      this.bizStackTraceOpen = true;
    },
    //操作记录
    openChangelog(row) {
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: row._id
        },
        res => {
          if (res) {
            if (res.data.length > 0) {
              // 不需要展示变更的字段名
              res.data = res.data.filter(item => {
                item.modifyList = item.modifyList.filter(obj => {
                  this.historyHide = this.historyHide || [];
                  return this.historyHide.indexOf(obj.field) == -1;
                });
                return item.modifyList.length > 0;
              });
              this.historyFpi = res;
            }
            this.openHistory = true;
          }
        },
        { noload: true }
      );
    },
    // //输入支付金额改变
    // paymentItemsChange(value, row) {
    //   if (!this.formData.paymentItems) this.formData.paymentItems = {};
    //   this.formData.paymentItems[row._id] = value;
    // },
    // //反显委托方
    // formatUserId(row, column, cellValue) {
    //   for (let item of this.contactList) {
    //     if (item._id == cellValue) return item.name;
    //   }
    // },
    // //计算差额
    // formatDifference(row) {
    //   let difference = this.amountToFixed(
    //     this.amountToFixed(row.totalAmount) - this.amountToFixed(row.paidAmount)
    //   );
    //   return Math.abs(difference) || 0;
    // },
    //退款细项金额保留两位小数
    refundablePriceBlur(row) {
      row._refundFee = +this.amountToFixed(row._refundFee) || '';
    },
    //保留两位小数的金额
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    //可退款金额最大值
    refundAmountMax(n1, n2) {
      n1 = n1 || 0;
      n2 = -Math.abs(n2) || 0;
      return this.amountToFixed(this.amountToFixed(n1) + this.amountToFixed(n2));
    },
    formatterCodelabel(cellValue, valueOption) {
      if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    formatterAuditstate(row, column, cellValue) {
      return this.osg.codelabel('auditstate', cellValue);
    },
    formatterPaymentRecordType(row) {
      if (!row) return '未知';
      return row.price > 0 ? '支付' : '退款';
    },
    formatterPayType(row, column, cellValue) {
      return this.osg.codelabel('payType', cellValue);
    },
    formatterPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderPayType', cellValue);
    },
    formatterTradeIn(row, column, cellValue) {
      return this.osg.codelabel('tradeIn', cellValue);
    },
    //标签
    formatterPayTag(row, column, cellValue) {
      return this.osg.codelabel('payTag', cellValue);
    }
  },
  watch: {
    $route() {
      window.$this = this;
      // // this.showList = false; //列表显示
      // this.type = this.$route.query.type || 0;
      // this.reviewType = this.$route.query.reviewType || 0; //优惠券审核
      // this.searchValue = ''; //切换页面清空过滤
      // this.getData();
      // //将过滤条件都删除
      window.sessionStorage.removeItem('filter');
      window.sessionStorage.removeItem('preFilter');
      this.viewReload();
    }
  }
};
</script>
<style>
#app #FinancialAuditDialog .el-dialog {
  width: 76% !important;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.el-table .default-row {
  /* background: #a6d4ffbd; */
  /* background: #cae5ff; */
  background: #e7f2fc;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style scoped>
input.el-input__inner {
  width: 230px;
}
</style>
